import Indentification from "../../components/elements/Indentification";
import { initialsValue } from "../../helpers";
import { useState } from "react";
import UserDropdownContent from "./UserDropdownContent";

const AdminHeader = ({ profile, role, setIsOpen = () => {}, isOpen }) => {
  // const [isOpen, setIsOpen] = useState(false);
  const data = {
    image: profile?.image?.url,
    name: profile?.firstName
      ? profile?.firstName + " " + profile?.lastName
      : "Admin",
    email: profile?.email || "admin123@gmail.com",
  };

  const toggleAccordion = () => setIsOpen((prev) => !prev);

  return (
    <>
    
      <header className="relative z-50 w-full border-t border-text-secondary/25 px-3 pt-3">
        <div className="mb-2 min-w-[4.5rem] rounded-xl bg-zinc-100 dark:bg-emerald-100 transition-all duration-300 ease-in-out">
          <div
            // className="flex items-center justify-between py-2 px-3 cursor-pointer"
            className="flex cursor-pointer gap-3 p-3 text-slate-700 hover:text-black-800 dark:hover:text-black-800 transition-all duration-300 ease-in-out relative"
            onClick={toggleAccordion}
          >
            <div className="flex items-center gap-2">
              {!data?.image ? (
                <div className="flex items-center justify-center bg-background-light text-primary w-12 md:w-12 h-12 md:h-12 rounded-md">
                  <i className="fa-regular fa-user" />
                </div>
              ) : (
                <Indentification
                  image={data.image}
                  alt={data.name || data.image}
                  initial={initialsValue(data.name)}
                />
              )}
              <div>
                <div className="flex basis-full items-center gap-2 truncate text-sm capitalize">
                  {data.name}
                </div>
                <div className="basis-full truncate text-xs  capitalize">
                  {profile?.role}
                </div>
              </div>
              {/* <div className="inline-flex items-center justify-center px-2 border-2 rounded-lg text-white bg-amber-500 border-transparent text-xs font-bold">
                PRO
              </div> */}
            </div>
            {/* <i className={`fa-solid fa-chevron-${isOpen ? "up" : "down"} text-xs`} /> */}
            {/* <span className="absolute top-0 right-0 text-xs text-blue-700"><i class="fa-solid fa-circle fa-fade"></i></span> */}
            {/* <div className="absolute top-0 right-0 w-4 h-4 flex justify-center items-center">
              <span className="absolute inline-flex h-full w-full rounded-full bg-blue-500 opacity-75 animate-ping"></span>
              <span className="relative inline-flex rounded-full h-4 w-4 bg-blue-700 border-2 border-white"></span>
            </div> */}
          </div>

          {isOpen && (
            <div className="px-3 pb-2 h-full">
              <UserDropdownContent data={data} role={profile?.role} />
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default AdminHeader;
